import script from "./WeekCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeekCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./WeekCalendar.vue?vue&type=style&index=0&id=32f2e72b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f2e72b"]])

export default __exports__